interface CancelModalProps {
  open: boolean;
  order: any | null;
  onClose: () => void;
  onConfirm: (order: any) => void;
}

export function CancelOrderModal({
  open,
  order,
  onClose,
  onConfirm,
}: CancelModalProps) {
  if (!open || !order) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          Annuler la commande
        </h3>

        <p className="text-gray-600 mb-6">
          Voulez-vous vraiment annuler le bon de commande :
          <br />
          <span className="font-semibold text-gray-900">
            {order.numero}
          </span>
          ?
        </p>

        <div className="bg-yellow-50 border border-yellow-200 text-yellow-800 text-sm rounded p-3 mb-6">
          ⚠️ Cette action est <strong>irréversible</strong>.  
          La commande passera au statut <strong>ANNULÉ</strong>.
        </div>

        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
          >
            Retour
          </button>

          <button
            type="button"
            onClick={() => onConfirm(order)}
            className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
          >
            Confirmer l’annulation
          </button>
        </div>
      </div>
    </div>
  );
}
